import { render, staticRenderFns } from "./classSubjectParamDetail.vue?vue&type=template&id=3c37d3ff"
import script from "./classSubjectParamDetail.vue?vue&type=script&lang=js"
export * from "./classSubjectParamDetail.vue?vue&type=script&lang=js"
import style0 from "./classSubjectParamDetail.vue?vue&type=style&index=0&id=3c37d3ff&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports